<div class="cell-avatar">
  <img
    src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
    class="avatar"
  />
  <div class="content">
    {{ title }}
  </div>
</div>
